/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import Stack from "@mui/material/Stack";
import {
  Button,
  ButtonGroup,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { getUserAttendanceList } from "app/redux/slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@jumbo/components/Loader";
import moment from "moment";
import { LocalizationProvider, DateRangePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useSnackbar } from "notistack";
import { Refresh } from "@mui/icons-material";
import { useParams } from "react-router-dom";

const QUICK_RANGES = [
  {
    key: "today",
    label: "Today",
    getRange: () => [
      moment().startOf("day").toDate(),
      moment().endOf("day").toDate(),
    ],
  },
  {
    key: "7d",
    label: "Last 7D",
    getRange: () => [
      moment().subtract(6, "days").startOf("day").toDate(),
      moment().endOf("day").toDate(),
    ],
  },
  {
    key: "30d",
    label: "Last 30D",
    getRange: () => [
      moment().subtract(29, "days").startOf("day").toDate(),
      moment().endOf("day").toDate(),
    ],
  },
  {
    key: "ytd",
    label: "YTD",
    getRange: () => [
      moment().startOf("year").toDate(),
      moment().endOf("day").toDate(),
    ],
  },
];
const UserAttendanceList = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  let { id } = useParams();

  const userData = useSelector((state) => state?.user);
  const [dateRange, setDateRange] = useState([
    moment().subtract(6, "days").startOf("day").toDate(),
    moment().endOf("day").toDate(),
  ]);
  const [order, setOrder] = useState(
    () => localStorage.getItem("user-order") || "desc"
  );
  const [orderBy, setOrderBy] = useState(
    () => localStorage.getItem("user-orderBy") || "createdAt"
  );

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "attendance-list" });

  const columns = [
    {
      id: "date",
      label: "Date",
      sort: true,
      minWidth: 200,
      render: (elm) => {
        const isSunday = elm?.date ? moment(elm.date).day() === 0 : false;
        return (
          <span
            style={{ color: isSunday || !elm?.checkInTime ? "red" : "inherit" }}
          >
            {elm?.date ? moment(elm.date).format("dddd, DD/MM/YYYY") : "-"}
          </span>
        );
      },
    },
    {
      id: "checkInTime",
      label: "Check In",
      sort: true,
      render: (elm) => {
        const isSunday = elm?.date ? moment(elm.date).day() === 0 : false;
        return (
          <span
            style={{
              color: !elm?.checkInTime
                ? isSunday
                  ? "inherit"
                  : "red"
                : "inherit",
            }}
          >
            {elm?.checkInTime ? moment(elm.checkInTime).format("hh:mm A") : "-"}
          </span>
        );
      },
    },
    {
      id: "checkOutTime",
      label: "Check Out",
      sort: true,
      render: (elm) => {
        const isSunday = elm?.date ? moment(elm.date).day() === 0 : false;
        return (
          <span
            style={{
              color: !elm?.checkInTime
                ? isSunday
                  ? "inherit"
                  : "red"
                : "inherit",
            }}
          >
            {elm?.checkOutTime
              ? moment(elm.checkOutTime).format("hh:mm A")
              : "-"}
          </span>
        );
      },
    },
    {
      id: "checkInCount",
      label: "Check In Count",
      sort: true,
      render: (elm) => {
        const isSunday = elm?.date ? moment(elm.date).day() === 0 : false;
        return (
          <span
            style={{
              color: !elm?.checkInTime
                ? isSunday
                  ? "inherit"
                  : "red"
                : "inherit",
            }}
          >
            {elm?.checkInCount}
          </span>
        );
      },
    },
    {
      id: "checkOutCount",
      label: "Check Out Count",
      sort: true,
      render: (elm) => {
        const isSunday = elm?.date ? moment(elm.date).day() === 0 : false;
        return (
          <span
            style={{
              color: !elm?.checkInTime
                ? isSunday
                  ? "inherit"
                  : "red"
                : "inherit",
            }}
          >
            {elm?.checkOutCount}
          </span>
        );
      },
    },
    {
      id: "totalTime",
      label: "Total Time",
      render: (elm) => {
        const duration = moment.duration(elm?.totalTime);
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        const formatted =
          (hours ? `${hours}h ` : "") +
          (minutes ? `${minutes}m ` : "") +
          (seconds ? `${seconds}s` : "");

        const isSunday = elm?.date ? moment(elm.date).day() === 0 : false;
        return (
          <span
            style={{
              color: !elm?.checkInTime
                ? isSunday
                  ? "inherit"
                  : "red"
                : "inherit",
            }}
          >
            {formatted || "0s"}{" "}
          </span>
        );
      },
    },
    {
      id: "totalTimeOfTheDay",
      label: "Total Time of the Day",
      render: (elm) => {
        const duration = moment.duration(elm?.totalTimeOfTheDay);
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        const formatted =
          (hours ? `${hours}h ` : "") +
          (minutes ? `${minutes}m ` : "") +
          (seconds ? `${seconds}s` : "");

        const isSunday = elm?.date ? moment(elm.date).day() === 0 : false;
        return (
          <span
            style={{
              color: !elm?.checkInTime
                ? isSunday
                  ? "inherit"
                  : "red"
                : "inherit",
            }}
          >
            {formatted || "0s"}{" "}
          </span>
        );
      },
    },
  ];

  const getData = () => {
    const params = { userId: id };
    if (dateRange[0] === null || dateRange[1] === null) {
      enqueueSnackbar("Please select both start and end date", {
        variant: "error",
      });
      return;
    }

    params.fromDate = moment(dateRange[0]).format("YYYY-MM-DD");
    params.toDate = moment(dateRange[1]).format("YYYY-MM-DD");
    dispatch(getUserAttendanceList(params));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, dispatch, order, orderBy]);
  const handleDateChange = (newDateRange) => {
    setDateRange(newDateRange);
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
    localStorage.setItem("user-order", Order);
    localStorage.setItem("user-orderBy", OrderBy);
  };
  return (
    <>
      {userData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
              >
                <Grid item xs={12} sm={4}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateRangePicker
                      startText="From Date - To Date"
                      endText="To Date"
                      inputFormat="dd/MM/yyyy"
                      value={dateRange}
                      onChange={handleDateChange}
                      renderInput={(
                        { inputProps, ...startProps },
                        endProps
                      ) => {
                        const startValue = inputProps.value;
                        delete inputProps.value;
                        return (
                          <TextField
                            {...startProps}
                            inputProps={inputProps}
                            value={`${startValue || "DD/MM/YYYY"} - ${
                              endProps.inputProps.value || "DD/MM/YYYY"
                            }`}
                            fullWidth
                            size="small"
                          />
                        );
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <ButtonGroup size="small" variant="outlined">
                      {QUICK_RANGES?.map((r) => (
                        <Button
                          key={r.key}
                          onClick={() => {
                            setDateRange(r.getRange());
                          }}
                          disabled={userData.loading}
                        >
                          {r.label}
                        </Button>
                      ))}
                    </ButtonGroup>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    variant="contained"
                    onClick={getData}
                    disabled={userData.loading}
                    startIcon={
                      userData.loading ? <CircularProgress size={16} /> : ""
                    }
                    fullWidth
                  >
                    Apply
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setDateRange([null, null]);
                    }}
                    disabled={userData.loading}
                    startIcon={<Refresh />}
                    fullWidth
                  >
                    Reset
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  {userData.userName} - Attendance List
                </Typography>
              </Stack>
              <Table
                columns={columns}
                rows={userData?.attendanceList}
                page={page}
                rowsPerPage={rowsPerPage}
                count={userData?.attendanceTotal}
                Order={order}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default UserAttendanceList;
